import { Flex, IRenderControl } from '@fareye/ui'
import React from 'react'
import { IIssue, IIssueListingApiConfig } from '../../../../utility/types'
import IssueCard from './IssueCard'

interface IIssueList {
  baseUrl: string
  config: IIssueListingApiConfig
  issues: any[]
  resourceType: string
  isClickable?: boolean
  t: (val: string) => any
}
const IssueList = ({
  baseUrl,
  config,
  issues,
  isClickable,
  resourceType = '',
  t
}: IIssueList) => {
  return (
    <Flex column>
      {issues &&
        issues.map((ele: IIssue, index: number) => {
          return (
            <IssueCard
              config={config}
              key={`issue${index}`}
              issue={ele}
              baseUrl={baseUrl}
              resourceType={resourceType}
              isClickable={isClickable}
              t={t}
            />
          )
        })}
    </Flex>
  )
}
export default IssueList
